import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  InputGroup,
  Badge,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaSearch,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import history from '~/Config/history';
import * as api from '~/Services/Service';

var opcoesFiltro = [
  { value: 'todos', label: 'Todos' },
  { value: 'descricao', label: 'Descrição' },
  { value: 'texto', label: 'Texto' },
  { value: 'menu', label: 'Menu' },
];

var Caracteristicas = function() {
  var _useState = function(val) {
    return useState(val);
  };

  var caracteristicasState = _useState([]);
  var caracteristicas = caracteristicasState[0];
  var setCaracteristicas = caracteristicasState[1];
  var loadingState = _useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var termoBuscaRef = useRef('');
  var termoBuscaInputRef = useRef(null);
  var temTermoBuscaState = _useState(false);
  var temTermoBusca = temTermoBuscaState[0];
  var setTemTermoBusca = temTermoBuscaState[1];
  var filtroState = _useState('todos');
  var filtro = filtroState[0];
  var setFiltro = filtroState[1];
  var filtroLocalState = _useState('');
  var filtroLocal = filtroLocalState[0];
  var setFiltroLocal = filtroLocalState[1];
  var filtroLocalTimerRef = useRef(null);
  var loadingAcaoState = _useState(false);
  var loadingAcao = loadingAcaoState[0];
  var setLoadingAcao = loadingAcaoState[1];

  // Modal criar/editar
  var showModalState = _useState(false);
  var showModal = showModalState[0];
  var setShowModal = showModalState[1];
  var caractEditandoState = _useState(null);
  var caractEditando = caractEditandoState[0];
  var setCaractEditando = caractEditandoState[1];
  var formCaractState = _useState({ nome: '', menu: '', texto: '' });
  var formCaract = formCaractState[0];
  var setFormCaract = formCaractState[1];

  // Modal excluir
  var showDeleteModalState = _useState(false);
  var showDeleteModal = showDeleteModalState[0];
  var setShowDeleteModal = showDeleteModalState[1];
  var caractParaExcluirState = _useState(null);
  var caractParaExcluir = caractParaExcluirState[0];
  var setCaractParaExcluir = caractParaExcluirState[1];
  var confirmacaoExclusaoState = _useState(false);
  var confirmacaoExclusao = confirmacaoExclusaoState[0];
  var setConfirmacaoExclusao = confirmacaoExclusaoState[1];

  // Modal grupos da característica
  var showGruposModalState = _useState(false);
  var showGruposModal = showGruposModalState[0];
  var setShowGruposModal = showGruposModalState[1];
  var caractGruposState = _useState(null);
  var caractGrupos = caractGruposState[0];
  var setCaractGrupos = caractGruposState[1];
  var gruposDaCaractState = _useState([]);
  var gruposDaCaract = gruposDaCaractState[0];
  var setGruposDaCaract = gruposDaCaractState[1];
  var loadingGruposState = _useState(false);
  var loadingGrupos = loadingGruposState[0];
  var setLoadingGrupos = loadingGruposState[1];
  var todosGruposState = _useState([]);
  var todosGrupos = todosGruposState[0];
  var setTodosGrupos = todosGruposState[1];
  var buscaGrupoState = _useState('');
  var buscaGrupo = buscaGrupoState[0];
  var setBuscaGrupo = buscaGrupoState[1];
  var buscaGrupoAtribState = _useState('');
  var buscaGrupoAtrib = buscaGrupoAtribState[0];
  var setBuscaGrupoAtrib = buscaGrupoAtribState[1];
  var loadingTodosGruposState = _useState(false);
  var loadingTodosGrupos = loadingTodosGruposState[0];
  var setLoadingTodosGrupos = loadingTodosGruposState[1];

  // Modal usuários diretos da característica
  var showUsuariosModalState = _useState(false);
  var showUsuariosModal = showUsuariosModalState[0];
  var setShowUsuariosModal = showUsuariosModalState[1];
  var caractUsuariosState = _useState(null);
  var caractUsuarios = caractUsuariosState[0];
  var setCaractUsuarios = caractUsuariosState[1];
  var usuariosDaCaractState = _useState([]);
  var usuariosDaCaract = usuariosDaCaractState[0];
  var setUsuariosDaCaract = usuariosDaCaractState[1];
  var loadingUsuariosState = _useState(false);
  var loadingUsuarios = loadingUsuariosState[0];
  var setLoadingUsuarios = loadingUsuariosState[1];
  var todosUsuariosState = _useState([]);
  var todosUsuarios = todosUsuariosState[0];
  var setTodosUsuarios = todosUsuariosState[1];
  var buscaUsuarioState = _useState('');
  var buscaUsuario = buscaUsuarioState[0];
  var setBuscaUsuario = buscaUsuarioState[1];
  var buscaUsuarioAtribState = _useState('');
  var buscaUsuarioAtrib = buscaUsuarioAtribState[0];
  var setBuscaUsuarioAtrib = buscaUsuarioAtribState[1];
  var loadingTodosUsuariosState = _useState(false);
  var loadingTodosUsuarios = loadingTodosUsuariosState[0];
  var setLoadingTodosUsuarios = loadingTodosUsuariosState[1];

  // Modal usuários indiretos
  var showIndiretoModalState = _useState(false);
  var showIndiretoModal = showIndiretoModalState[0];
  var setShowIndiretoModal = showIndiretoModalState[1];
  var caractIndiretoState = _useState(null);
  var caractIndireto = caractIndiretoState[0];
  var setCaractIndireto = caractIndiretoState[1];
  var usuariosIndiretoState = _useState([]);
  var usuariosIndireto = usuariosIndiretoState[0];
  var setUsuariosIndireto = usuariosIndiretoState[1];
  var loadingIndiretoState = _useState(false);
  var loadingIndireto = loadingIndiretoState[0];
  var setLoadingIndireto = loadingIndiretoState[1];
  var buscaIndiretoState = _useState('');
  var buscaIndireto = buscaIndiretoState[0];
  var setBuscaIndireto = buscaIndiretoState[1];

  // Confirmação de remoção
  var showConfirmRemocaoState = _useState(false);
  var showConfirmRemocao = showConfirmRemocaoState[0];
  var setShowConfirmRemocao = showConfirmRemocaoState[1];
  var remocaoPendenteState = _useState(null);
  var remocaoPendente = remocaoPendenteState[0];
  var setRemocaoPendente = remocaoPendenteState[1];

  // Ordenação
  var ordenacaoState = _useState({ campo: 'codigo', direcao: 'asc' });
  var ordenacao = ordenacaoState[0];
  var setOrdenacao = ordenacaoState[1];

  var handleOrdenacao = function(campo) {
    setOrdenacao(function(prev) {
      if (prev.campo === campo) {
        return {
          campo: campo,
          direcao: prev.direcao === 'asc' ? 'desc' : 'asc',
        };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function(campo) {
    if (ordenacao.campo !== campo)
      return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc' ? (
      <FaSortUp style={{ marginLeft: 4 }} />
    ) : (
      <FaSortDown style={{ marginLeft: 4 }} />
    );
  };

  var thSortStyle = {
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',
  };

  useEffect(function() {
    buscarCaracteristicas();
  }, []);

  var buscarCaracteristicas = async function() {
    setLoading(true);
    try {
      var res = await api.listarCaracteristicasCatalogo(
        termoBuscaRef.current,
        filtro
      );
      setCaracteristicas(res || []);
    } catch (e) {
      toast.error('Erro ao carregar características');
    } finally {
      setLoading(false);
    }
  };

  var handleBuscar = function() {
    setPagina(1);
    buscarCaracteristicas();
  };

  var handleLimparBusca = function() {
    termoBuscaRef.current = '';
    if (termoBuscaInputRef.current) termoBuscaInputRef.current.value = '';
    setTemTermoBusca(false);
    setPagina(1);
    buscarCaracteristicas();
  };

  var handleAbrirNovo = function() {
    setCaractEditando(null);
    setFormCaract({ nome: '', menu: '', texto: '' });
    setShowModal(true);
  };

  var handleAbrirEditar = function(caract) {
    setCaractEditando(caract);
    setFormCaract({
      nome: caract.nome || '',
      menu: caract.menu || '',
      texto: caract.texto || '',
    });
    setShowModal(true);
  };

  var handleSalvar = async function() {
    if (!formCaract.nome.trim()) {
      toast.warn('Nome é obrigatório');
      return;
    }
    setLoadingAcao(true);
    try {
      if (caractEditando) {
        await api.atualizarCaracteristica(caractEditando.codigo, {
          nome: formCaract.nome.trim(),
          menu: formCaract.menu.trim(),
          texto: formCaract.texto.trim(),
        });
        toast.success('Característica atualizada com sucesso!');
      } else {
        await api.criarCaracteristica({
          nome: formCaract.nome.trim(),
          menu: formCaract.menu.trim(),
          texto: formCaract.texto.trim(),
        });
        toast.success('Característica criada com sucesso!');
      }
      setShowModal(false);
      buscarCaracteristicas();
    } catch (e) {
      toast.error('Erro ao salvar característica');
    } finally {
      setLoadingAcao(false);
    }
  };

  var handleAbrirExcluir = function(caract) {
    setCaractParaExcluir(caract);
    setConfirmacaoExclusao(false);
    setShowDeleteModal(true);
  };

  var handleExcluir = async function() {
    if (!confirmacaoExclusao) {
      toast.warn('Marque a confirmação para prosseguir com a exclusão');
      return;
    }
    setLoadingAcao(true);
    try {
      await api.excluirCaracteristica(caractParaExcluir.codigo);
      toast.success('Característica excluída com sucesso!');
      setShowDeleteModal(false);
      buscarCaracteristicas();
    } catch (e) {
      var msg = (e && e.message) || 'Erro ao excluir característica';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  var linkStyle = {
    cursor: 'pointer',
    color: '#0747a6',
    textDecoration: 'underline',
    fontWeight: 'bold',
  };

  // Handlers dos modais de grupos e usuários
  var handleAbrirGrupos = async function(caract) {
    setCaractGrupos(caract);
    setGruposDaCaract([]);
    setTodosGrupos([]);
    setBuscaGrupo('');
    setBuscaGrupoAtrib('');
    setShowGruposModal(true);
    setLoadingGrupos(true);
    try {
      var resVinculados = await api.listarGruposPorCaracteristica(
        caract.codigo
      );
      setGruposDaCaract(resVinculados || []);
      var resTodos = await api.listarGruposUsuario();
      setTodosGrupos(resTodos || []);
    } catch (e) {
      toast.error('Erro ao carregar grupos');
    } finally {
      setLoadingGrupos(false);
    }
  };

  var handleAdicionarAoGrupo = async function(grupo) {
    try {
      await api.incluirCaracteristicaGrupo(grupo.codigo, {
        codigo_caracteristica: caractGrupos.codigo,
      });
      toast.success('Característica adicionada ao grupo!');
      setGruposDaCaract(function(prev) {
        return prev.concat([{ codigo: grupo.codigo, nome: grupo.nome }]);
      });
      atualizarContador(caractGrupos.codigo, 'qtd_grupos', 1);
    } catch (e) {
      var msg =
        (e && e.response && e.response.data && e.response.data.message) ||
        'Erro ao adicionar ao grupo';
      toast.error(msg);
    }
  };

  var handleRemoverDoGrupo = function(codigoGrupo) {
    setRemocaoPendente({ tipo: 'grupo', codigoGrupo: codigoGrupo });
    setShowConfirmRemocao(true);
  };

  var executarRemocaoGrupo = async function() {
    var codigoGrupo = remocaoPendente.codigoGrupo;
    setShowConfirmRemocao(false);
    setRemocaoPendente(null);
    try {
      await api.excluirCaracteristicaGrupo(codigoGrupo, caractGrupos.codigo);
      toast.success('Característica removida do grupo!');
      setGruposDaCaract(function(prev) {
        return prev.filter(function(g) {
          return g.codigo !== codigoGrupo;
        });
      });
      atualizarContador(caractGrupos.codigo, 'qtd_grupos', -1);
    } catch (e) {
      toast.error('Erro ao remover característica do grupo');
    }
  };

  var handleAbrirUsuarios = async function(caract) {
    setCaractUsuarios(caract);
    setUsuariosDaCaract([]);
    setTodosUsuarios([]);
    setBuscaUsuario('');
    setBuscaUsuarioAtrib('');
    setShowUsuariosModal(true);
    setLoadingUsuarios(true);
    try {
      var resVinculados = await api.listarUsuariosDiretoCaracteristica(
        caract.codigo
      );
      setUsuariosDaCaract(resVinculados || []);
      var resTodos = await api.obterUsuarios();
      setTodosUsuarios(resTodos || []);
    } catch (e) {
      toast.error('Erro ao carregar usuários');
    } finally {
      setLoadingUsuarios(false);
    }
  };

  var handleAdicionarAoUsuario = async function(usuario) {
    try {
      await api.incluirCaracteristicaUsuario(usuario.codigo, {
        codigo_caracteristica: caractUsuarios.codigo,
      });
      toast.success('Característica atribuída ao usuário!');
      setUsuariosDaCaract(function(prev) {
        return prev.concat([
          {
            codigo: usuario.codigo,
            nome: usuario.nome,
            nome_completo: usuario.nome_completo || usuario.nome,
            email: usuario.email,
          },
        ]);
      });
      atualizarContador(caractUsuarios.codigo, 'qtd_usuarios_direto', 1);
    } catch (e) {
      var msg =
        (e && e.response && e.response.data && e.response.data.message) ||
        'Erro ao atribuir ao usuário';
      toast.error(msg);
    }
  };

  var handleRemoverDoUsuario = function(codigoUsuario) {
    setRemocaoPendente({ tipo: 'usuario', codigoUsuario: codigoUsuario });
    setShowConfirmRemocao(true);
  };

  var executarRemocaoUsuario = async function() {
    var codigoUsuario = remocaoPendente.codigoUsuario;
    setShowConfirmRemocao(false);
    setRemocaoPendente(null);
    try {
      await api.excluirCaracteristicaUsuario(
        codigoUsuario,
        caractUsuarios.codigo
      );
      toast.success('Característica removida do usuário!');
      setUsuariosDaCaract(function(prev) {
        return prev.filter(function(u) {
          return u.codigo !== codigoUsuario;
        });
      });
      atualizarContador(caractUsuarios.codigo, 'qtd_usuarios_direto', -1);
    } catch (e) {
      toast.error('Erro ao remover característica do usuário');
    }
  };

  var executarRemocao = function() {
    if (remocaoPendente && remocaoPendente.tipo === 'grupo')
      executarRemocaoGrupo();
    else if (remocaoPendente && remocaoPendente.tipo === 'usuario')
      executarRemocaoUsuario();
  };

  var handleAbrirIndireto = async function(caract) {
    setCaractIndireto(caract);
    setUsuariosIndireto([]);
    setBuscaIndireto('');
    setShowIndiretoModal(true);
    setLoadingIndireto(true);
    try {
      var res = await api.listarUsuariosIndiretoCaracteristica(caract.codigo);
      setUsuariosIndireto(res || []);
    } catch (e) {
      toast.error('Erro ao carregar usuários indiretos');
    } finally {
      setLoadingIndireto(false);
    }
  };

  var atualizarContador = function(codigoCaract, campo, delta) {
    setCaracteristicas(function(prev) {
      return prev.map(function(c) {
        if (c.codigo === codigoCaract) {
          var updated = Object.assign({}, c);
          updated[campo] = (updated[campo] || 0) + delta;
          return updated;
        }
        return c;
      });
    });
  };

  var dadosFiltrados = caracteristicas
    .filter(function(c) {
      if (!filtroLocal) return true;
      var termo = filtroLocal.toLowerCase();
      return (
        String(c.codigo).indexOf(termo) >= 0 ||
        (c.nome && c.nome.toLowerCase().indexOf(termo) >= 0) ||
        (c.texto && c.texto.toLowerCase().indexOf(termo) >= 0) ||
        (c.menu && c.menu.toLowerCase().indexOf(termo) >= 0)
      );
    })
    .sort(function(a, b) {
      var campo = ordenacao.campo;
      var dir = ordenacao.direcao === 'asc' ? 1 : -1;
      var valA = a[campo];
      var valB = b[campo];
      if (valA == null) valA = '';
      if (valB == null) valB = '';
      if (campo === 'nome' || campo === 'menu' || campo === 'texto') {
        return (
          dir *
          String(valA)
            .toLowerCase()
            .localeCompare(String(valB).toLowerCase())
        );
      }
      return dir * (Number(valA) - Number(valB));
    });

  var ITENS_POR_PAGINA = 50;
  var paginaState = _useState(1);
  var pagina = paginaState[0];
  var setPagina = paginaState[1];
  var totalPaginas = Math.ceil(dadosFiltrados.length / ITENS_POR_PAGINA) || 1;
  var dadosPaginados = dadosFiltrados.slice(
    (pagina - 1) * ITENS_POR_PAGINA,
    pagina * ITENS_POR_PAGINA
  );

  if (loading && caracteristicas.length === 0) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>
        {
          '\
        .caract-desktop { display: block; }\
        .caract-mobile  { display: none; }\
        .modal-header-blue .close { color: #fff; opacity: 0.8; }\
        .modal-header-blue .close:hover { opacity: 1; }\
        @media (max-width: 768px) {\
          .caract-desktop { display: none !important; }\
          .caract-mobile  { display: block; }\
          .caract-filtro-row { flex-direction: column; }\
          .caract-filtro-row > [class*="col"] { margin-bottom: 8px; flex: 0 0 100%; max-width: 100%; }\
          .caract-filtro-row .text-right { text-align: right !important; }\
          .caract-mobile .card { overflow: hidden; word-break: break-word; }\
          .container-fluid { padding-left: 8px !important; padding-right: 8px !important; }\
          .modal-body .row > [class*="col"] { flex: 0 0 100%; max-width: 100%; margin-bottom: 12px; }\
        }\
      '
        }
      </style>

      <Header title="Catálogo de Características" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center caract-filtro-row">
            <Col md={2}>
              <Form.Control
                as="select"
                size="sm"
                value={filtro}
                onChange={function(e) {
                  setFiltro(e.target.value);
                }}
              >
                {opcoesFiltro.map(function(o) {
                  return (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  );
                })}
              </Form.Control>
            </Col>
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <div style={{ position: 'relative', flex: 1, display: 'flex' }}>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="Buscar na API por nome, texto ou menu..."
                    ref={termoBuscaInputRef}
                    defaultValue={termoBuscaRef.current}
                    onChange={function(e) {
                      termoBuscaRef.current = e.target.value;
                      setTemTermoBusca(!!e.target.value);
                    }}
                    onKeyDown={function(e) {
                      if (e.key === 'Enter') handleBuscar();
                    }}
                    style={{ paddingRight: '2rem', borderRadius: 0 }}
                  />
                  {temTermoBusca && (
                    <span
                      onClick={handleLimparBusca}
                      style={{
                        position: 'absolute',
                        right: '0.5rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: '#6c757d',
                        fontSize: '1rem',
                        lineHeight: 1,
                      }}
                      title="Limpar busca"
                    >
                      &times;
                    </span>
                  )}
                </div>
                <InputGroup.Append>
                  <Button variant="primary" size="sm" onClick={handleBuscar}>
                    Buscar
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Filtrar resultados..."
                  defaultValue=""
                  onChange={function(e) {
                    var val = e.target.value;
                    if (filtroLocalTimerRef.current)
                      clearTimeout(filtroLocalTimerRef.current);
                    filtroLocalTimerRef.current = setTimeout(function() {
                      setFiltroLocal(val);
                      setPagina(1);
                    }, 300);
                  }}
                />
              </InputGroup>
            </Col>
            <Col md={2}>
              <Button
                size="sm"
                variant="success"
                className="w-100"
                onClick={handleAbrirNovo}
              >
                <FaPlus className="mr-1" /> Nova Característica
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm" style={{ opacity: loading ? 0.5 : 1, transition: 'opacity 0.2s', pointerEvents: loading ? 'none' : 'auto' }}>
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Características
            <span
              className="ml-2"
              style={{ fontSize: '0.85rem', opacity: 0.8 }}
            >
              {loading ? 'Buscando...' : '(' + dadosFiltrados.length + ' ' + (dadosFiltrados.length === 1 ? 'registro' : 'registros') + ')'}
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {dadosFiltrados.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtroLocal
                ? 'Nenhuma característica encontrada para o filtro informado.'
                : 'Nenhuma característica cadastrada.'}
            </p>
          ) : (
            <>
              {/* Desktop */}
              <div className="caract-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th
                        style={Object.assign({ width: '70px' }, thSortStyle)}
                        onClick={function() {
                          handleOrdenacao('codigo');
                        }}
                      >
                        #{iconeOrdenacao('codigo')}
                      </th>
                      <th
                        style={Object.assign({ width: '220px' }, thSortStyle)}
                        onClick={function() {
                          handleOrdenacao('nome');
                        }}
                      >
                        Nome{iconeOrdenacao('nome')}
                      </th>
                      <th
                        style={Object.assign({}, thSortStyle)}
                        onClick={function() {
                          handleOrdenacao('texto');
                        }}
                      >
                        Descrição{iconeOrdenacao('texto')}
                      </th>
                      <th
                        style={Object.assign(
                          { width: '90px', textAlign: 'center' },
                          thSortStyle
                        )}
                        onClick={function() {
                          handleOrdenacao('qtd_grupos');
                        }}
                      >
                        Grupos{iconeOrdenacao('qtd_grupos')}
                      </th>
                      <th
                        style={Object.assign(
                          { width: '90px', textAlign: 'center' },
                          thSortStyle
                        )}
                        onClick={function() {
                          handleOrdenacao('qtd_usuarios_direto');
                        }}
                      >
                        Direto{iconeOrdenacao('qtd_usuarios_direto')}
                      </th>
                      <th
                        style={Object.assign(
                          { width: '90px', textAlign: 'center' },
                          thSortStyle
                        )}
                        onClick={function() {
                          handleOrdenacao('qtd_usuarios_indireto');
                        }}
                      >
                        Indireto{iconeOrdenacao('qtd_usuarios_indireto')}
                      </th>
                      <th style={{ width: '100px', textAlign: 'center' }}>
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosPaginados.map(function(c) {
                      return (
                        <tr key={c.codigo}>
                          <td>{c.codigo}</td>
                          <td>{c.nome}</td>
                          <td>{c.texto || '-'}</td>
                          <td className="text-center">
                            <span
                              style={linkStyle}
                              onClick={function() {
                                handleAbrirGrupos(c);
                              }}
                            >
                              {c.qtd_grupos != null ? c.qtd_grupos : 0}
                            </span>
                          </td>
                          <td className="text-center">
                            <span
                              style={linkStyle}
                              onClick={function() {
                                handleAbrirUsuarios(c);
                              }}
                            >
                              {c.qtd_usuarios_direto != null
                                ? c.qtd_usuarios_direto
                                : 0}
                            </span>
                          </td>
                          <td className="text-center">
                            {(c.qtd_usuarios_indireto || 0) > 0 ? (
                              <span
                                style={linkStyle}
                                onClick={function() {
                                  handleAbrirIndireto(c);
                                }}
                              >
                                {c.qtd_usuarios_indireto}
                              </span>
                            ) : (
                              <span style={{ color: '#6c757d' }}>0</span>
                            )}
                          </td>
                          <td
                            className="text-center"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <Button
                              size="sm"
                              variant="info"
                              title="Editar"
                              className="mr-1"
                              onClick={function() {
                                handleAbrirEditar(c);
                              }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="danger"
                              title={
                                c.qtd_grupos > 0 ||
                                c.qtd_usuarios_direto > 0 ||
                                c.qtd_usuarios_indireto > 0
                                  ? 'Não é possível excluir: característica vinculada'
                                  : 'Excluir'
                              }
                              disabled={
                                c.qtd_grupos > 0 ||
                                c.qtd_usuarios_direto > 0 ||
                                c.qtd_usuarios_indireto > 0
                              }
                              onClick={function() {
                                handleAbrirExcluir(c);
                              }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="caract-mobile p-2">
                {dadosPaginados.map(function(c) {
                  return (
                    <Card key={c.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>
                              {c.nome}
                            </strong>
                            <br />
                            <small className="text-muted">#{c.codigo}</small>
                            {c.texto && (
                              <small className="text-muted ml-2">
                                | {c.texto}
                              </small>
                            )}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2"
                          style={{ fontSize: '0.85rem' }}
                        >
                          <span
                            style={linkStyle}
                            onClick={function() {
                              handleAbrirGrupos(c);
                            }}
                          >
                            <Badge variant="secondary" className="mr-1">
                              {c.qtd_grupos != null ? c.qtd_grupos : 0}
                            </Badge>{' '}
                            grupos
                          </span>
                          <span
                            style={linkStyle}
                            onClick={function() {
                              handleAbrirUsuarios(c);
                            }}
                          >
                            <Badge variant="info" className="mr-1">
                              {c.qtd_usuarios_direto != null
                                ? c.qtd_usuarios_direto
                                : 0}
                            </Badge>{' '}
                            direto
                          </span>
                          <span
                            style={(c.qtd_usuarios_indireto || 0) > 0 ? linkStyle : { color: '#6c757d' }}
                            onClick={(c.qtd_usuarios_indireto || 0) > 0 ? function() {
                              handleAbrirIndireto(c);
                            } : undefined}
                          >
                            <Badge variant={(c.qtd_usuarios_indireto || 0) > 0 ? 'warning' : 'light'} className="mr-1">
                              {c.qtd_usuarios_indireto || 0}
                            </Badge>{' '}
                            indireto
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <Button
                            size="sm"
                            variant="info"
                            onClick={function() {
                              handleAbrirEditar(c);
                            }}
                          >
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button
                            size="sm"
                            variant="danger"
                            disabled={
                              c.qtd_grupos > 0 ||
                              c.qtd_usuarios_direto > 0 ||
                              c.qtd_usuarios_indireto > 0
                            }
                            onClick={function() {
                              handleAbrirExcluir(c);
                            }}
                          >
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
          {dadosFiltrados.length > ITENS_POR_PAGINA && (
            <div
              className="d-flex justify-content-between align-items-center px-3 py-2"
              style={{ borderTop: '1px solid #dee2e6' }}
            >
              <small className="text-muted">
                Página {pagina} de {totalPaginas} ({dadosFiltrados.length}{' '}
                registros)
              </small>
              <div>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  className="mr-1"
                  disabled={pagina <= 1}
                  onClick={function() {
                    setPagina(pagina - 1);
                  }}
                >
                  &laquo; Anterior
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  disabled={pagina >= totalPaginas}
                  onClick={function() {
                    setPagina(pagina + 1);
                  }}
                >
                  Próxima &raquo;
                </Button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Modal: Criar/Editar Característica */}
      <Modal
        show={showModal}
        onHide={function() {
          setShowModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {caractEditando
              ? 'Editar Característica #' + caractEditando.codigo
              : 'Nova Característica'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {caractEditando && (
            <Form.Group className="mb-2">
              <Form.Label>Código</Form.Label>
              <Form.Control
                type="text"
                value={caractEditando.codigo}
                readOnly
                disabled
              />
            </Form.Group>
          )}
          <Form.Group className="mb-2">
            <Form.Label>
              Nome <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={formCaract.nome}
              onChange={function(e) {
                setFormCaract(
                  Object.assign({}, formCaract, { nome: e.target.value })
                );
              }}
              placeholder="Nome da característica"
              onKeyDown={function(e) {
                if (e.key === 'Enter') handleSalvar();
              }}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Menu</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={formCaract.menu}
              onChange={function(e) {
                setFormCaract(
                  Object.assign({}, formCaract, { menu: e.target.value })
                );
              }}
              placeholder="Caminho de menu (ex: Configurações > Usuários)"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Texto</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formCaract.texto}
              onChange={function(e) {
                setFormCaract(
                  Object.assign({}, formCaract, { texto: e.target.value })
                );
              }}
              placeholder="Descrição completa da característica"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={function() {
              setShowModal(false);
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSalvar}
            disabled={loadingAcao}
          >
            {loadingAcao ? 'Salvando...' : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: Excluir com dupla confirmação */}
      <Modal
        show={showDeleteModal}
        onHide={function() {
          setShowDeleteModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Excluir Característica</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Você está prestes a excluir a característica{' '}
            <strong>
              #{caractParaExcluir && caractParaExcluir.codigo} —{' '}
              {caractParaExcluir && caractParaExcluir.nome}
            </strong>
            .
          </p>
          <div className="alert alert-danger" role="alert">
            <strong>Atenção:</strong> Esta ação removerá a característica de{' '}
            <strong>TODOS</strong> os grupos e usuários que a possuem. Esta
            operação é irreversível.
          </div>
          <Form.Check
            type="checkbox"
            id="confirmacao-exclusao"
            label="Entendo o impacto desta ação e confirmo a exclusão"
            checked={confirmacaoExclusao}
            onChange={function(e) {
              setConfirmacaoExclusao(e.target.checked);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={function() {
              setShowDeleteModal(false);
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleExcluir}
            disabled={loadingAcao || !confirmacaoExclusao}
          >
            {loadingAcao ? 'Excluindo...' : 'Excluir Definitivamente'}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal: Grupos da Característica */}
      {showGruposModal && (
        <Modal
          show={showGruposModal}
          onHide={function() {
            setShowGruposModal(false);
          }}
          size="lg"
          centered
        >
          <Modal.Header
            closeButton
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
            className="modal-header-blue"
          >
            <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>
              Grupos com a característica: {caractGrupos && caractGrupos.nome}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="d-flex align-items-stretch">
              <Col md={6} className="d-flex">
                <Card className="border w-100 d-flex flex-column">
                  <Card.Header
                    className="py-2 d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    <strong style={{ fontSize: '0.9rem' }}>
                      Grupos Disponíveis
                    </strong>
                    {todosGrupos.length > 0 && (
                      <Badge variant="secondary">{todosGrupos.length}</Badge>
                    )}
                  </Card.Header>
                  <div
                    className="px-2 py-2"
                    style={{ borderBottom: '1px solid #dee2e6' }}
                  >
                    <InputGroup size="sm">
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FaSearch size={12} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        placeholder="Filtrar por nome ou código..."
                        value={buscaGrupo}
                        onChange={function(e) {
                          setBuscaGrupo(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <Card.Body className="p-0" style={{ flex: 1 }}>
                    {loadingGrupos ? (
                      <p className="text-center py-3 mb-0">Carregando...</p>
                    ) : todosGrupos.length > 0 ? (
                      (function() {
                        var gruposFilt = todosGrupos.filter(function(g) {
                          if (!buscaGrupo) return true;
                          var t = buscaGrupo.toLowerCase();
                          return (
                            String(g.codigo).indexOf(t) >= 0 ||
                            (g.nome && g.nome.toLowerCase().indexOf(t) >= 0)
                          );
                        });
                        var gruposVisiveis = gruposFilt.slice(0, 50);
                        return (
                          <div>
                            {gruposFilt.length > 50 && (
                              <p className="text-muted small text-center py-1 mb-0">
                                Mostrando 50 de {gruposFilt.length} — refine o
                                filtro
                              </p>
                            )}
                            <div
                              style={{ maxHeight: '350px', overflowY: 'auto' }}
                            >
                              {gruposVisiveis.map(function(g) {
                                var jaIncluso = gruposDaCaract.some(function(
                                  gc
                                ) {
                                  return gc.codigo === g.codigo;
                                });
                                return (
                                  <div
                                    key={g.codigo}
                                    className="d-flex justify-content-between align-items-center px-3 py-2"
                                    style={{
                                      borderBottom: '1px solid #f0f0f0',
                                      backgroundColor: jaIncluso
                                        ? '#e8f5e9'
                                        : 'transparent',
                                    }}
                                  >
                                    <span style={{ fontSize: '0.9rem' }}>
                                      <Badge variant="light" className="mr-1">
                                        {g.codigo}
                                      </Badge>
                                      {g.nome}
                                    </span>
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                      {jaIncluso ? (
                                        <Badge variant="success">
                                          já incluso
                                        </Badge>
                                      ) : (
                                        <Button
                                          size="sm"
                                          variant="success"
                                          onClick={function() {
                                            handleAdicionarAoGrupo(g);
                                          }}
                                        >
                                          <FaPlus />
                                        </Button>
                                      )}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })()
                    ) : (
                      <p className="text-muted small text-center py-3 mb-0">
                        Nenhum grupo cadastrado.
                      </p>
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="d-flex">
                <Card className="border w-100 d-flex flex-column">
                  <Card.Header
                    className="py-2 d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    <strong style={{ fontSize: '0.9rem' }}>
                      Com esta característica
                    </strong>
                    <Badge variant="info">{gruposDaCaract.length}</Badge>
                  </Card.Header>
                  <div
                    className="px-2 py-2"
                    style={{ borderBottom: '1px solid #dee2e6' }}
                  >
                    <InputGroup size="sm">
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FaSearch size={12} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        placeholder="Filtrar por nome ou código..."
                        value={buscaGrupoAtrib}
                        onChange={function(e) {
                          setBuscaGrupoAtrib(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <Card.Body className="p-0" style={{ flex: 1 }}>
                    {loadingGrupos ? (
                      <p className="text-center py-3 mb-0">Carregando...</p>
                    ) : gruposDaCaract.length === 0 ? (
                      <p className="text-muted small text-center py-3 mb-0">
                        Nenhum grupo vinculado.
                      </p>
                    ) : (
                      (function() {
                        var termoGAtrib = buscaGrupoAtrib.toLowerCase().trim();
                        var filtrados = termoGAtrib
                          ? gruposDaCaract.filter(function(g) {
                              return (
                                String(g.codigo).indexOf(termoGAtrib) !== -1 ||
                                (g.nome || '')
                                  .toLowerCase()
                                  .indexOf(termoGAtrib) !== -1
                              );
                            })
                          : gruposDaCaract;
                        return filtrados.length === 0 ? (
                          <p className="text-muted small text-center py-3 mb-0">
                            Nenhum resultado para o filtro.
                          </p>
                        ) : (
                          <div>
                            {filtrados.length > 50 && (
                              <p className="text-muted small text-center py-1 mb-0">
                                Mostrando 50 de {filtrados.length} — refine o
                                filtro
                              </p>
                            )}
                            <div
                              style={{ maxHeight: '350px', overflowY: 'auto' }}
                            >
                              {filtrados.slice(0, 50).map(function(g) {
                                return (
                                  <div
                                    key={g.codigo}
                                    className="d-flex justify-content-between align-items-center px-3 py-2"
                                    style={{
                                      borderBottom: '1px solid #f0f0f0',
                                    }}
                                  >
                                    <span style={{ fontSize: '0.9rem' }}>
                                      <Badge variant="light" className="mr-1">
                                        {g.codigo}
                                      </Badge>
                                      {g.nome}
                                    </span>
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={function() {
                                        handleRemoverDoGrupo(g.codigo);
                                      }}
                                    >
                                      <FaTrash size={12} />
                                    </Button>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })()
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={function() {
                setShowGruposModal(false);
              }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal: Usuários Diretos da Característica */}
      {showUsuariosModal && (
        <Modal
          show={showUsuariosModal}
          onHide={function() {
            setShowUsuariosModal(false);
          }}
          size="lg"
          centered
        >
          <Modal.Header
            closeButton
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
            className="modal-header-blue"
          >
            <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>
              Usuários com atribuição direta:{' '}
              {caractUsuarios && caractUsuarios.nome}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="d-flex align-items-stretch">
              <Col md={6} className="d-flex">
                <Card className="border w-100 d-flex flex-column">
                  <Card.Header
                    className="py-2 d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    <strong style={{ fontSize: '0.9rem' }}>
                      Usuários Disponíveis
                    </strong>
                    {todosUsuarios.length > 0 && (
                      <Badge variant="secondary">{todosUsuarios.length}</Badge>
                    )}
                  </Card.Header>
                  <div
                    className="px-2 py-2"
                    style={{ borderBottom: '1px solid #dee2e6' }}
                  >
                    <InputGroup size="sm">
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FaSearch />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        type="text"
                        placeholder="Filtrar por código, nome ou e-mail..."
                        value={buscaUsuario}
                        onChange={function(e) {
                          setBuscaUsuario(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <Card.Body className="p-0" style={{ flex: 1 }}>
                    {loadingUsuarios ? (
                      <p className="text-center py-3 mb-0">Carregando...</p>
                    ) : todosUsuarios.length > 0 ? (
                      (function() {
                        var usuariosFilt = todosUsuarios.filter(function(u) {
                          if (!buscaUsuario) return true;
                          var t = buscaUsuario.toLowerCase();
                          return (
                            String(u.codigo).indexOf(t) >= 0 ||
                            (u.nome && u.nome.toLowerCase().indexOf(t) >= 0) ||
                            (u.nome_completo &&
                              u.nome_completo.toLowerCase().indexOf(t) >= 0) ||
                            (u.email && u.email.toLowerCase().indexOf(t) >= 0)
                          );
                        });
                        var usuariosVisiveis = usuariosFilt.slice(0, 50);
                        return (
                          <div>
                            {usuariosFilt.length > 50 && (
                              <p className="text-muted small text-center py-1 mb-0">
                                Mostrando 50 de {usuariosFilt.length} — refine o
                                filtro
                              </p>
                            )}
                            <div
                              style={{ maxHeight: '350px', overflowY: 'auto' }}
                            >
                              {usuariosVisiveis.map(function(u) {
                                var jaIncluso = usuariosDaCaract.some(function(
                                  uc
                                ) {
                                  return uc.codigo === u.codigo;
                                });
                                return (
                                  <div
                                    key={u.codigo}
                                    className="d-flex justify-content-between align-items-center px-3 py-2"
                                    style={{
                                      borderBottom: '1px solid #f0f0f0',
                                      backgroundColor: jaIncluso
                                        ? '#e8f5e9'
                                        : 'transparent',
                                    }}
                                  >
                                    <span style={{ fontSize: '0.85rem' }}>
                                      <Badge variant="light" className="mr-1">
                                        {u.codigo}
                                      </Badge>
                                      {u.nome_completo || u.nome}
                                    </span>
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                      {jaIncluso ? (
                                        <Badge variant="success">
                                          já incluso
                                        </Badge>
                                      ) : (
                                        <Button
                                          size="sm"
                                          variant="success"
                                          onClick={function() {
                                            handleAdicionarAoUsuario(u);
                                          }}
                                        >
                                          <FaPlus />
                                        </Button>
                                      )}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })()
                    ) : (
                      <p className="text-muted small text-center py-3 mb-0">
                        Nenhum usuário cadastrado.
                      </p>
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="d-flex">
                <Card className="border w-100 d-flex flex-column">
                  <Card.Header
                    className="py-2 d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    <strong style={{ fontSize: '0.9rem' }}>
                      Com Atribuição Direta
                    </strong>
                    <Badge variant="info">{usuariosDaCaract.length}</Badge>
                  </Card.Header>
                  <div
                    className="px-2 py-2"
                    style={{ borderBottom: '1px solid #dee2e6' }}
                  >
                    <InputGroup size="sm">
                      <InputGroup.Prepend>
                        <InputGroup.Text>
                          <FaSearch size={12} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        placeholder="Filtrar por nome ou código..."
                        value={buscaUsuarioAtrib}
                        onChange={function(e) {
                          setBuscaUsuarioAtrib(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <Card.Body className="p-0" style={{ flex: 1 }}>
                    {loadingUsuarios ? (
                      <p className="text-center py-3 mb-0">Carregando...</p>
                    ) : usuariosDaCaract.length === 0 ? (
                      <p className="text-muted small text-center py-3 mb-0">
                        Nenhum usuário com atribuição direta.
                      </p>
                    ) : (
                      (function() {
                        var termoAtrib = buscaUsuarioAtrib.toLowerCase().trim();
                        var filtrados = termoAtrib
                          ? usuariosDaCaract.filter(function(u) {
                              return (
                                String(u.codigo).indexOf(termoAtrib) !== -1 ||
                                (u.nome_completo || u.nome || '')
                                  .toLowerCase()
                                  .indexOf(termoAtrib) !== -1
                              );
                            })
                          : usuariosDaCaract;
                        return filtrados.length === 0 ? (
                          <p className="text-muted small text-center py-3 mb-0">
                            Nenhum resultado para o filtro.
                          </p>
                        ) : (
                          <div
                            style={{ maxHeight: '350px', overflowY: 'auto' }}
                          >
                            {filtrados.slice(0, 50).map(function(u) {
                              return (
                                <div
                                  key={u.codigo}
                                  className="d-flex justify-content-between align-items-center px-3 py-2"
                                  style={{ borderBottom: '1px solid #f0f0f0' }}
                                >
                                  <span style={{ fontSize: '0.85rem' }}>
                                    <Badge variant="light" className="mr-1">
                                      {u.codigo}
                                    </Badge>
                                    {u.nome_completo || u.nome}
                                  </span>
                                  <span style={{ whiteSpace: 'nowrap' }}>
                                    <Button
                                      size="sm"
                                      variant="info"
                                      title="Editar usuário"
                                      className="mr-1"
                                      onClick={function() {
                                        history.push(
                                          '/usuarios/' + u.codigo
                                        );
                                      }}
                                    >
                                      <FaExternalLinkAlt size={12} />
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={function() {
                                        handleRemoverDoUsuario(u.codigo);
                                      }}
                                    >
                                      <FaTrash size={12} />
                                    </Button>
                                  </span>
                                </div>
                              );
                            })}
                            {filtrados.length > 50 && (
                              <p className="text-muted small text-center py-1 mb-0">
                                Mostrando 50 de {filtrados.length} — refine o
                                filtro
                              </p>
                            )}
                          </div>
                        );
                      })()
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={function() {
                setShowUsuariosModal(false);
              }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal: Usuários Indiretos */}
      {showIndiretoModal && (
        <Modal
          show={showIndiretoModal}
          onHide={function() {
            setShowIndiretoModal(false);
          }}
          size="lg"
          centered
        >
          <Modal.Header
            closeButton
            style={{ backgroundColor: '#0747a6', color: '#fff' }}
            className="modal-header-blue"
          >
            <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>
              Usuários indiretos (via grupo):{' '}
              {caractIndireto && caractIndireto.nome}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <FaSearch />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Filtrar por código, nome ou grupo..."
                    value={buscaIndireto}
                    onChange={function(e) {
                      setBuscaIndireto(e.target.value);
                    }}
                  />
                </InputGroup>
              </Col>
            </Row>
            {loadingIndireto ? (
              <Loading />
            ) : usuariosIndireto.length === 0 ? (
              <p className="text-muted text-center">
                Nenhum usuário possui esta característica indiretamente.
              </p>
            ) : (
              (function() {
                var indiretosFiltrados = usuariosIndireto.filter(function(u) {
                  if (!buscaIndireto) return true;
                  var t = buscaIndireto.toLowerCase();
                  return (
                    String(u.codigo_usuario).indexOf(t) >= 0 ||
                    (u.nome_usuario &&
                      u.nome_usuario.toLowerCase().indexOf(t) >= 0) ||
                    (u.nome_completo &&
                      u.nome_completo.toLowerCase().indexOf(t) >= 0) ||
                    String(u.codigo_grupo).indexOf(t) >= 0 ||
                    (u.nome_grupo && u.nome_grupo.toLowerCase().indexOf(t) >= 0)
                  );
                });
                return (
                  <>
                    <p className="text-muted small mb-2">
                      {indiretosFiltrados.length}{' '}
                      {indiretosFiltrados.length === 1
                        ? 'registro'
                        : 'registros'}
                    </p>
                    {/* Desktop */}
                    <div
                      className="caract-desktop"
                      style={{ maxHeight: '400px', overflowY: 'auto' }}
                    >
                      <Table striped bordered hover size="sm" className="mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: '70px' }}>#</th>
                            <th>Nome</th>
                            <th>Grupo (origem)</th>
                            <th style={{ width: '60px', textAlign: 'center' }}>
                              Ação
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {indiretosFiltrados.map(function(u, idx) {
                            return (
                              <tr
                                key={
                                  u.codigo_usuario +
                                  '-' +
                                  u.codigo_grupo +
                                  '-' +
                                  idx
                                }
                              >
                                <td>{u.codigo_usuario}</td>
                                <td>{u.nome_completo || u.nome_usuario}</td>
                                <td>
                                  <Badge variant="light" className="mr-1">
                                    {u.codigo_grupo}
                                  </Badge>
                                  {u.nome_grupo}
                                </td>
                                <td className="text-center">
                                  <Button
                                    size="sm"
                                    variant="info"
                                    title="Editar usuário"
                                    onClick={function() {
                                      history.push(
                                        '/usuarios/' +
                                          u.codigo_usuario
                                      );
                                    }}
                                  >
                                    <FaExternalLinkAlt />
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                    {/* Mobile */}
                    <div
                      className="caract-mobile"
                      style={{ maxHeight: '400px', overflowY: 'auto' }}
                    >
                      {indiretosFiltrados.map(function(u, idx) {
                        return (
                          <Card
                            key={
                              u.codigo_usuario +
                              '-' +
                              u.codigo_grupo +
                              '-' +
                              idx
                            }
                            className="mb-2 shadow-sm"
                          >
                            <Card.Body className="py-2 px-3">
                              <div className="d-flex justify-content-between align-items-start mb-1">
                                <div>
                                  <strong style={{ fontSize: '0.95rem' }}>
                                    {u.nome_completo || u.nome_usuario}
                                  </strong>
                                  <br />
                                  <small className="text-muted">
                                    #{u.codigo_usuario}
                                  </small>
                                </div>
                                <Button
                                  size="sm"
                                  variant="info"
                                  onClick={function() {
                                    history.push(
                                      '/usuarios/' +
                                        u.codigo_usuario
                                    );
                                  }}
                                >
                                  <FaExternalLinkAlt />
                                </Button>
                              </div>
                              <div style={{ fontSize: '0.85rem' }}>
                                <Badge variant="secondary" className="mr-1">
                                  {u.codigo_grupo}
                                </Badge>
                                {u.nome_grupo}
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                    </div>
                  </>
                );
              })()
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={function() {
                setShowIndiretoModal(false);
              }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal: Confirmar Remoção */}
      <Modal
        show={showConfirmRemocao}
        onHide={function() {
          setShowConfirmRemocao(false);
          setRemocaoPendente(null);
        }}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>
            Confirmar Remoção
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {remocaoPendente && remocaoPendente.tipo === 'grupo'
            ? 'Deseja remover esta característica do grupo?'
            : 'Deseja remover esta característica do usuário?'}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={function() {
              setShowConfirmRemocao(false);
              setRemocaoPendente(null);
            }}
          >
            Cancelar
          </Button>
          <Button variant="danger" size="sm" onClick={executarRemocao}>
            Remover
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Caracteristicas;
